export default "__VITE_ASSET__fb02dcd9__"